import { AppBar, Box, Divider, Link, Toolbar } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import BrandLogo from '@/components/BrandLogo'

const BlogNavbar = (props) => (
    <AppBar
        elevation={0}
        sx={{
            backgroundColor: 'background.paper',
            pl: 'env(safe-area-inset-left, 0px)',
            pr: 'env(safe-area-inset-right, 0px)'
        }}
        {...props}
    >
        <Toolbar sx={{ minHeight: 64 }}>
            <RouterLink to="/">
                <BrandLogo height={60} />
            </RouterLink>
            <Box sx={{ flexGrow: 1 }} />
            <Link
                color="textSecondary"
                component={RouterLink}
                to="/"
                underline="none"
                variant="body1"
            >
                Home
            </Link>
            <Link
                color="textPrimary"
                component={RouterLink}
                to="/blog"
                underline="none"
                sx={{ mx: 2 }}
                variant="body1"
            >
                Blog
            </Link>
            <Link
                color="textSecondary"
                component={RouterLink}
                to="/contact"
                underline="none"
                variant="body1"
            >
                Contact Us
            </Link>
        </Toolbar>
        <Divider />
    </AppBar>
)

export default BlogNavbar
